import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/inputs/Button";
import List from "../components/inputs/List";
import PROJECT_CONFIG from "../config/projectConfig";

const Application = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Application</h1>

          {/* Requirements Section */}
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-500 pb-2">
              Requirements
            </h2>
            <p className="text-gray-700 mb-6">
              Members of the Scientific Resolution Panel ({PROJECT_CONFIG.name})
              Cadre of experts must meet or exceed the following requirements:
            </p>

            {/* Professional & Educational Qualifications */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Professional & Educational Qualifications
              </h3>
              <List
                items={[
                  "Minimum of 10 year of professional experience",
                  "Educational degree(s) in field of expertise",
                  "Professional license in field of expertise (if applicable)",
                ]}
                withMargin
              />
            </div>

            {/* Other Relevant Qualifications */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Other Relevant Qualifications
              </h3>
              <List
                items={[
                  "Membership in professional or business association(s)",
                  "Research or published works in field of expertise",
                ]}
                withMargin
              />
            </div>

            {/* Neutrality/Impartiality */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Neutrality/Impartiality
              </h3>
              <List
                items={[
                  "Able to render unbiased evaluation and opinion based on technical data",
                  "Able to decide fairly and impartially",
                  "Must fully disclose conflicts of interest or any circumstances that might be perceived as constituting a conflict of interest or a bias in favor of or against either party of an assigned submittal.",
                ]}
                withMargin
              />
            </div>

            {/* Commitment */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Commitment
              </h3>
              <List
                items={[
                  "Willingness to serve as Chair of a Panel",
                  "Willingness to devote the equivalent of 2 to 5 days of time and effort over the course of 90 days when selected for a Panel",
                  "Willingness to serve on a Panel at least once per year",
                  `Willingness to learn the ${PROJECT_CONFIG.name} Rules and Procedures`,
                  "Willingness to provide two letters of recommendation from active professionals in the field (if requested)",
                ]}
                withMargin
              />
            </div>

            {/* Agreement */}
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Agreement
              </h3>
              <List
                items={[
                  "Attest to accuracy of content of application",
                  "Maintain integrity of personal, professional and conflict of interest status by updating records annually",
                  "Sign Cadre Member and Non-Disclosure Agreement",
                  "Recertify qualification records prior to serving on Panel",
                  "Sign a Panelist engagement agreement with NIBS as an Independent Subcontractor",
                ]}
                withMargin
              />
            </div>

            {/* Certification */}
            <div className="mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Certification
              </h3>
              <p className="text-gray-700">
                Read the {PROJECT_CONFIG.name} Rules and Procedures and selected
                sections of the National Flood Insurance Program Statutes and
                Regulations listed on the online application
              </p>
            </div>
          </div>

          {/* Apply Now Button */}
          <div className="text-center">
            <Button
              variant="primary"
              size="lg"
              className=""
              onClick={() => navigate("/cadre-application")}
            >
              Apply now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Application;
